"use client";

/**
 * Adaptador fino: a apresentação mora em `@tami/ui/web`
 * (`LoadingIndicator`, que recebe `pending` por prop porque o pacote não
 * importa Next). Aqui só se resolve o `useLinkStatus` do `next/link`, que só
 * funciona dentro da árvore de um `<Link>`, e repassa o resultado.
 */
import { useLinkStatus } from "next/link";
import { LoadingIndicator } from "@tami/ui/web";

export default function LoadingIndicatorAdapter() {
  const { pending } = useLinkStatus();
  return <LoadingIndicator pending={pending} />;
}
